import Item from "./Item";

const DocumentDownload = ({ items, download }) => {
  return (
    <div className="miltis-recap__documents--list">
      {items.map((item, index) => (
        <Item
          key={`key-${index}`}
          name={item.name}
          size={item.size}
          onDownload={() => download(item.id)}
        />
      ))}
    </div>
  );
};

export default DocumentDownload;
